import { KdsCheckbox } from "@kazaar-platform/design-system";
import { Controller, useFormContext } from "react-hook-form";
import { type ControlledCheckboxProps } from "./ControlledCheckbox.types";

const ControlledCheckbox = ({
  name,
  ...inputProps
}: ControlledCheckboxProps) => {
  const { control, formState } = useFormContext();

  const error = formState.errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <KdsCheckbox
          {...inputProps}
          isError={!!error}
          isChecked={field.value}
          label={inputProps.label}
          onChange={field.onChange}
        />
      )}
    />
  );
};

export { ControlledCheckbox };
